// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* -----------------------------------------------------------------------------
// DESPLEGABLE
// ----------------------------------------------------------------------------- */
.empleo-formacion .desplegables{ margin-bottom: 75px; }

.empleo-formacion .desplegable{
  border-bottom: 2px solid #007932;
  padding: 16px 12px 12px 12px;
  width: fit-content;
}

.empleo-formacion .recursos .desplegable{ width: 100%; }

.empleo-formacion .desplegable h2{ 
  font-size: 18px;
  line-height: 1.2;
}

.modal-overlay .modal-body ul,
.empleo-formacion .desplegable-contenido ul{ 
  list-style: none;
  padding-left: 7.5px;
  margin-top: 10px;
}

.modal-overlay .modal-body li{ 
  margin: 5px 0px; 
  border: none;
}

.empleo-formacion .desplegable-contenido li{ margin: 2.5px 0px; }
.empleo-formacion .desplegable-contenido a{ color: black; }
.empleo-formacion .desplegable-contenido a:hover{ text-decoration: underline; }


/* -----------------------------------------------------------------------------
// BOTONES PARA TÉCNICOS
// ----------------------------------------------------------------------------- */
.social-empleo-formacion .botones-crear{
    margin-top: 80px;
    gap: 15px;
}

.empleo-formacion .botones-crear a{
    padding: 10px 20px;
    border: 2px solid #007932;
    border-radius: 12px;
  }
  
  .empleo-formacion .botones-crear a:hover{
    color: white;
    background-color: #007932;
    text-decoration: none;
  }


/* -----------------------------------------------------------------------------
// MODAL CONTENT - RECURSOS DONDE ENCONTRAR MÁS EMPLEOS, CURSOS...
// ----------------------------------------------------------------------------- */
.main.empleo-formacion .modal-header svg{ color: white;}
.main.empleo-formacion .modal-header .close-button{ border-radius: 5px; }

.main.empleo-formacion .modal-header .close-button:hover svg{ 
  color: #007932;
  background-color: white;
}

.empleo-formacion .botones-crear .formacion{
  color: #b90248;
  border: 2px solid #b90248;
}

.empleo-formacion .botones-crear .formacion:hover{
  color: #fff;
  background-color:  #b90248;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/css/Empleo.css"],"names":[],"mappings":";AACA;;kFAEkF;AAClF,iCAAiC,mBAAmB,EAAE;;AAEtD;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,0CAA0C,WAAW,EAAE;;AAEvD;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,6CAA6C,iBAAiB,EAAE;AAChE,4CAA4C,YAAY,EAAE;AAC1D,kDAAkD,0BAA0B,EAAE;;;AAG9E;;kFAEkF;AAClF;IACI,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;EACvB;;;AAGF;;kFAEkF;AAClF,0CAA0C,YAAY,CAAC;AACvD,oDAAoD,kBAAkB,EAAE;;AAExE;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B","sourcesContent":["\n/* -----------------------------------------------------------------------------\n// DESPLEGABLE\n// ----------------------------------------------------------------------------- */\n.empleo-formacion .desplegables{ margin-bottom: 75px; }\n\n.empleo-formacion .desplegable{\n  border-bottom: 2px solid #007932;\n  padding: 16px 12px 12px 12px;\n  width: fit-content;\n}\n\n.empleo-formacion .recursos .desplegable{ width: 100%; }\n\n.empleo-formacion .desplegable h2{ \n  font-size: 18px;\n  line-height: 1.2;\n}\n\n.modal-overlay .modal-body ul,\n.empleo-formacion .desplegable-contenido ul{ \n  list-style: none;\n  padding-left: 7.5px;\n  margin-top: 10px;\n}\n\n.modal-overlay .modal-body li{ \n  margin: 5px 0px; \n  border: none;\n}\n\n.empleo-formacion .desplegable-contenido li{ margin: 2.5px 0px; }\n.empleo-formacion .desplegable-contenido a{ color: black; }\n.empleo-formacion .desplegable-contenido a:hover{ text-decoration: underline; }\n\n\n/* -----------------------------------------------------------------------------\n// BOTONES PARA TÉCNICOS\n// ----------------------------------------------------------------------------- */\n.social-empleo-formacion .botones-crear{\n    margin-top: 80px;\n    gap: 15px;\n}\n\n.empleo-formacion .botones-crear a{\n    padding: 10px 20px;\n    border: 2px solid #007932;\n    border-radius: 12px;\n  }\n  \n  .empleo-formacion .botones-crear a:hover{\n    color: white;\n    background-color: #007932;\n    text-decoration: none;\n  }\n\n\n/* -----------------------------------------------------------------------------\n// MODAL CONTENT - RECURSOS DONDE ENCONTRAR MÁS EMPLEOS, CURSOS...\n// ----------------------------------------------------------------------------- */\n.main.empleo-formacion .modal-header svg{ color: white;}\n.main.empleo-formacion .modal-header .close-button{ border-radius: 5px; }\n\n.main.empleo-formacion .modal-header .close-button:hover svg{ \n  color: #007932;\n  background-color: white;\n}\n\n.empleo-formacion .botones-crear .formacion{\n  color: #b90248;\n  border: 2px solid #b90248;\n}\n\n.empleo-formacion .botones-crear .formacion:hover{\n  color: #fff;\n  background-color:  #b90248;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
